import * as types from './actionTypes';
import axios from 'axios';
import { setGlobalErrors } from './globalErrorActions';
import { getHeader, getMessageByErrorStatus } from '../helper';

function requestProducts() {
  return {
    type: types.GET_PRODUCTS_REQUEST
  }
}

function receiveProducts(data) {
  return {
    type: types.GET_PRODUCTS_SUCCESS,
    data
  }
}

function productsError(messages) {
  return {
    type: types.GET_PRODUCTS_FAILURE,
    messages
  }
}

export function getProducts(params, headers) {
  return function(dispatch) {
    dispatch(requestProducts());
    dispatch(setGlobalErrors('product', {}));

    let newHeaders = headers ? headers : {headers:{}};
    
    axios.get(
      `${window.siteUrl}/api/v1/photo_video_pack/`, {
        params,
        headers: newHeaders.headers
    })
    .then(response => {
      dispatch(receiveProducts(response.data))
    })
    .catch(error => {
        console.error("GetProducts Error:", error)
        dispatch(productsError(error));
      if(error.response) {
        let errorText = getMessageByErrorStatus(error.response.status);
        dispatch(setGlobalErrors('product', {status: error.response.status, error: errorText}));
      }
    })
  }
}


function requestMoreProducts() {
  return {
    type: types.GET_MORE_PRODUCTS_REQUEST
  }
}

function receiveMoreProducts(data) {
  return {
    type: types.GET_MORE_PRODUCTS_SUCCESS,
    data
  }
}

function errorMoreProducts(messages) {
  return {
    type: types.GET_MORE_PRODUCTS_FAILURE,
    messages
  }
}

export function getMoreProducts(next, params, headers) {
  let newHeaders = headers ? headers : {headers:{}};

  return function(dispatch) {
    dispatch(requestMoreProducts());
    dispatch(setGlobalErrors('product', {}));

    axios.get(
      `${next}`, {
      params,
      headers: newHeaders.headers
    })
    .then(response => {
      dispatch(receiveMoreProducts(response.data))
    })
    .catch(error => {
      console.error("GetProducts more Error:", error)
      dispatch(errorMoreProducts(error));
      let errorText = getMessageByErrorStatus(error.response.status);
      dispatch(setGlobalErrors('product', {status: error.response.status, error: errorText}));
    })
  }
}


function buyPackRequest() {
  return {
    type: types.BUY_PACK_REQUEST
  }
}

function buyPackReceive(data) {
  return {
    type: types.BUY_PACK_RECEIVE,
    data
  }
}

function buyPackError(messages) {
  return {
    type: types.BUY_PACK_FAILURE,
    messages
  }
}

export function buyPack(params, afterSuccess, afterError) {
  return function(dispatch) {
    dispatch(buyPackRequest);
    dispatch(setGlobalErrors('product', {}));

    let newParams = params.company_id ? {company_id: params.company_id} : {};

    axios.post(
      `${window.siteUrl}/api/v1/photo_video_pack/${params.id}/buy/`,
      newParams,
      {
        headers: getHeader()
      }
    )
    .then(response => {
      dispatch(buyPackReceive(response.data));
      if(afterSuccess) afterSuccess(response.data)
    })
    .catch(error => {
      dispatch(buyPackError(error.data));
      if(afterError) afterError(error.data);

      let errorText = getMessageByErrorStatus(error.response.status);
      dispatch(setGlobalErrors('product', {status: error.response.status, error: errorText}));
    }) 
  }
}


function requestAddPackLike() {
  return {
      type: types.ADD_PACK_LIKE_REQUEST,
  }
}

function receiveAddPackLike(pack) {
  return {
      type: types.ADD_PACK_LIKE_SUCCESS,
      pack
  }
}

function addPackLikeError(messages) {
  return {
      type: types.ADD_PACK_LIKE_FAILURE,
      messages
  }
}

export function addPackLike(pack) {
  return function (dispatch) {
      dispatch(requestAddPackLike());
      dispatch(setGlobalErrors('product', {}));

      return axios.post(
          `${window.siteUrl}/api/v1/photo_video_pack/${pack.id}/add_like/`,
          {},
          {
              headers: getHeader()
          }
      )
      .then(function (response) {
        dispatch(receiveAddPackLike(pack));
      })
      .catch(function (error) {
        console.error("add_pack_like error", error);
        dispatch(addPackLikeError(error));
        let errorText = getMessageByErrorStatus(error.response.status);
        dispatch(setGlobalErrors('product', {status: error.response.status, error: errorText}));
      });
  }
}


function requestAddPackDislike() {
  return {
      type: types.ADD_PACK_DISLIKE_REQUEST,
  }
}

function receiveAddPackDislike(pack) {
  return {
      type: types.ADD_PACK_DISLIKE_SUCCESS,
      pack
  }
}

function addPackDislikeError(messages) {
  return {
      type: types.ADD_PACK_DISLIKE_FAILURE,
      messages
  }
}

export function addPackDislike(pack) {
  return function (dispatch) {
      dispatch(requestAddPackDislike());
      dispatch(setGlobalErrors('product', {}));

      return axios.post(
          `${window.siteUrl}/api/v1/photo_video_pack/${pack.id}/add_dislike/`,
          {},
          {
              headers: getHeader()
          }
      )
      .then(function (response) {
        dispatch(receiveAddPackDislike(pack));
      })
      .catch(function (error) {
        console.error("add_pack_like error", error);
        dispatch(addPackDislikeError(error));

        let errorText = getMessageByErrorStatus(error.response.status);
        dispatch(setGlobalErrors('product', {status: error.response.status, error: errorText}));
      });
  }
}


// WEBPACK FOOTER //
// ./src/actions/buyActions.js